import { use } from 'react';
import {
  AuthContext,
  AuthContextType,
} from '@/contexts/auth-context-definition';

export const useAuth = (): AuthContextType => {
  const context = use(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
